<div class="list_panel {{pageName ? 'show' : ''}}">
    <div class="list_panel__header {{isScrolled ? 'shadow' : ''}}">
        <div class="list_panel__title">{{TEXT.listPageTitle[pageName]}}</div>
        <div class="list_panel__close" (click)="toClose.emit()"></div>
    </div>

    <div class="list_panel__scroll scroll" #scrollElem>
        <ng-content></ng-content>
    </div>
</div>